import ChatDetailsHeader from "./header/ChatDetailsHeader";
import ChatDetailsActions from "./actions/ChatDetailsActions";

import TransitionView from "@components/shared/TransitionView";

import ChatAvatar from "@/components/shared/ChatAvatar";
import { useNavigationState } from "@/zustand/NavigationState";

import ChatDetailsTabs from "./tabs/ChatDetailsTabs";

export default function RightColumn() {
  const activeChatId = useNavigationState((state) => state.activeChatId);
  const showChatDetails = useNavigationState((state) => state.showChatDetails);
  const toggleChatDetails = useNavigationState(
    (state) => state.toggleChatDetails,
  );

  const activeChatName = useNavigationState((state) => state.activeChatName);
  const activeChatDescription = useNavigationState(
    (state) => state.activeChatDescription,
  );

  const activeChatAvatar = useNavigationState(
    (state) => state.activeChatAvatar,
  );

  if (!activeChatId || !showChatDetails) {
    return null;
  }

  return (
    <TransitionView
      id="RightColumn"
      className="shrink-0 lg:w-[calc(100vw-440px)] 3xl:w-rightColumnWidth"
      onCloseThreshold={0.7}
      trigger={!!showChatDetails}
      onClose={() => toggleChatDetails()}
    >
      <div className="flex size-full flex-col overflow-hidden bg-card 3xl:border-l 3xl:border-border">
        {/* HEADER */}
        <ChatDetailsHeader />

        {/* AVATAR */}
        <div className="mb-5 flex shrink-0 flex-col items-center gap-2 p-5">
          <ChatAvatar
            className="mb-5 size-24 items-center justify-center"
            chatId={activeChatId}
            chatName={activeChatName}
            attachmentId={activeChatAvatar?.attachmentId}
            secondMemberId={activeChatAvatar?.secondMemberId}
          />
          <h5 className="text-md font-semibold leading-none">
            {activeChatName}
          </h5>
          {activeChatDescription && (
            <h6 className="text-sm leading-none tracking-tight text-foreground/50">
              {activeChatDescription}
            </h6>
          )}
        </div>
        {/* ACTIONS */}
        <ChatDetailsActions />

        {/* TABS */}

        <ChatDetailsTabs />
      </div>
    </TransitionView>
  );
}
